module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-view"
  }, [(_vm.sites.length === 0 && _vm.sitesFinishedLoading) ? _c('erco-layout-template-selection', {
    attrs: {
      "sets": _vm.templateSets
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sites.length > 0) ? _c('erco-layout-preview-block', {
    staticClass: "preview-block",
    attrs: {
      "datasets": _vm.sites
    }
  }) : _vm._e(), _vm._v(" "), _c('erco-back-to-top-button', {
    attrs: {
      "thresholdType": "windowHeight"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b98091b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoObjectView/Layout.vue
// module id = 620
// module chunks = 0